import React from 'react'
import classNames from 'classnames'

import './styles.css'

const InputTextarea = ({ onChange, placeholder, rows = 4, name, value }) => {
  return (
    <textarea
      rows={rows}
      name={name}
      onChange={onChange}
      placeholder={placeholder}
      value={value}
      className={classNames(
        'josefin ba b--moon-gray ph4 pv3 w-100 db',
        'input-focus br2 mb3 f11 resize-v min-h90'
      )}
    />
  )
}

export default InputTextarea
